import type {
  CategoryDTO,
  CategoryCreateInput,
  CategoryUpdateInput,
} from "@/modules/categories/domain/contracts";
import type { OffsetPageDTO } from "@/shared/contracts/base";
import { config } from "@/shared/lib/config";
import { fetcher } from "@/shared/lib/fetcher";
import type { OffsetPageQueryDTO } from "@/shared/contracts/base";

export type { CategoryDTO };

export const catalogApi = {
  categories: {
    async list(query: OffsetPageQueryDTO): Promise<OffsetPageDTO<CategoryDTO>> {
      const url = new URL(`${config.apiUrl}/categories`);
      url.searchParams.set("limit", String(query.limit ?? 20));
      url.searchParams.set("offset", String(query.offset ?? 0));
      if (query.sort) url.searchParams.set("sort", JSON.stringify(query.sort));
      if (query.filters)
        url.searchParams.set("filters", JSON.stringify(query.filters));
      return fetcher.get<OffsetPageDTO<CategoryDTO>>(url.toString());
    },
    async get(id: string): Promise<CategoryDTO> {
      return fetcher.get<CategoryDTO>(`${config.apiUrl}/categories/${id}`);
    },
    async create(input: CategoryCreateInput): Promise<CategoryDTO> {
      return fetcher.post<CategoryDTO>(
        `${config.apiUrl}/categories`,
        input,
      );
    },
    async update(id: string, input: CategoryUpdateInput): Promise<CategoryDTO> {
      return fetcher.put<CategoryDTO>(
        `${config.apiUrl}/categories/${id}`,
        input,
      );
    },
    async remove(id: string): Promise<{ ok: boolean }> {
      return fetcher.delete<{ ok: boolean }>(
        `${config.apiUrl}/categories/${id}`,
      );
    },
  },
};
